
import React from 'react';

interface StatCardProps {
  label: string;
  value: string | number;
  icon: React.ReactNode;
  trend?: string;
  color?: 'purple' | 'green' | 'red' | 'blue';
}

const StatCard: React.FC<StatCardProps> = ({ label, value, icon, trend, color = 'purple' }) => {
  const colorMap = {
    purple: 'text-purple-400 bg-purple-500/10 border-purple-500/20',
    green: 'text-emerald-400 bg-emerald-500/10 border-emerald-500/20',
    red: 'text-rose-400 bg-rose-500/10 border-rose-500/20',
    blue: 'text-sky-400 bg-sky-500/10 border-sky-500/20',
  };

  return (
    <div className="relative group overflow-hidden glass-panel p-10 rounded-[2.5rem] border border-white/5 hover:border-white/10 transition-all duration-500 hover:-translate-y-1">
      <div className={`absolute top-0 right-0 w-24 h-24 blur-[60px] opacity-0 group-hover:opacity-20 transition-opacity ${color === 'purple' ? 'bg-purple-600' : color === 'green' ? 'bg-emerald-600' : color === 'red' ? 'bg-rose-600' : 'bg-sky-600'}`}></div>
      
      <div className="flex justify-between items-start relative z-10">
        <div className="space-y-4">
          <p className="text-slate-500 text-[10px] font-black uppercase tracking-[0.3em]">{label}</p>
          <h3 className="text-4xl font-black text-white tracking-tight">{value}</h3>
        </div>
        <div className={`p-4 rounded-2xl ${colorMap[color]} border shadow-inner transition-transform duration-500 group-hover:scale-110`}>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {icon}
          </svg>
        </div>
      </div>
      
      {trend && (
        <div className="mt-8 pt-8 border-t border-white/5 flex items-center justify-between relative z-10">
          <div className="flex items-center space-x-2 text-emerald-400 font-bold text-xs bg-emerald-500/5 px-3 py-1.5 rounded-full border border-emerald-500/10">
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 10l7-7m0 0l7 7m-7-7v18" /></svg>
            <span className="tracking-tight">{trend}</span>
          </div>
          <span className="text-[9px] text-slate-500 font-black uppercase tracking-widest opacity-60">System Log</span>
        </div>
      )}
    </div>
  );
};

export default StatCard;
